<template>
  <div class="border border-gray-200 dark:border-dark-border rounded-lg overflow-hidden">
    <button
      @click="toggle"
      class="w-full flex items-center justify-between p-6 text-left hover:bg-gray-50 dark:hover:bg-dark-surface/50 transition-colors duration-200"
      :aria-expanded="isOpen"
    >
      <h3 class="text-lg font-display font-semibold text-gray-900 dark:text-white pr-4">
        {{ question }}
      </h3>
      <ChevronDown
        :size="24"
        :class="[
          'text-primary dark:text-accent flex-shrink-0 transition-transform duration-300',
          isOpen ? 'rotate-180' : ''
        ]"
      />
    </button>

    <transition
      name="expand"
      @enter="enter"
      @after-enter="afterEnter"
      @leave="leave"
    >
      <div v-show="isOpen" class="overflow-hidden">
        <div class="p-6 pt-0 text-base md:text-lg text-gray-600 dark:text-gray-300 leading-relaxed">
          <slot>{{ answer }}</slot>
        </div>
      </div>
    </transition>
  </div>
</template>

<script setup>
import { ref } from 'vue';
import { ChevronDown } from 'lucide-vue-next';

defineProps({
  question: {
    type: String,
    required: true
  },
  answer: {
    type: String,
    default: ''
  },
  defaultOpen: {
    type: Boolean,
    default: false
  }
});

const isOpen = ref(false);

const toggle = () => {
  isOpen.value = !isOpen.value;
};

const enter = (element) => {
  element.style.height = '0';
  element.offsetHeight; // Trigger reflow
  element.style.height = element.scrollHeight + 'px';
};

const afterEnter = (element) => {
  element.style.height = 'auto';
};

const leave = (element) => {
  element.style.height = element.scrollHeight + 'px';
  element.offsetHeight; // Trigger reflow
  element.style.height = '0';
};
</script>

<style scoped>
.expand-enter-active,
.expand-leave-active {
  transition: height 0.3s ease;
}
</style>
